import * as api from '../../services/customerConfig'

export const FETCH_CUSTOMERS = 'FETCH_CUSTOMERS';
export const FETCH_CUSTOMER = 'FETCH_CUSTOMER';



export const fetchCustomer = (id) => {
    return {
        type: FETCH_CUSTOMER,
        payload: {
            promise: api.findCustomer({id: id})
        }
    }
}


export const fetchCustomers = (params, pagination, sort, extra) => {
    return {
        type: FETCH_CUSTOMERS,
        payload: {
            promise: api.findCustomers(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    }
}



// WEBPACK FOOTER //
// ./src/redux/actions/customerConfig.js